import React from 'react'
import t from 'helpers/I18n'
import { useParams } from 'react-router';
import PropTypes from 'prop-types'
import StepsWrapper from "steps/steps-wrapper";
import BaseParagraph from "components/base-components/base-paragraph";
import BaseButton from "components/base-components/base-button";
import StepsLoader from "../steps-loader";
import { VscFilePdf } from "react-icons/vsc"
import { IoMdOpen } from "react-icons/io"
import { AppDataContext } from '../../../contexts/app-data';
import { BASE_URL } from '../../../env';
import { useState } from 'react';
import { useHistory } from "react-router-dom";


// const _satellite = window._satellite
const PageBus = window.PageBus

const TextBody = ({lang}) =>(
    <>
        <h3 className="sup-title" style={{textAlign: "center"}}> {t('Welcome_Product.title')}</h3>
        <h3 className="sub-title" style={{textAlign: "center"}}>{t('Welcome_Product.sub_title')}</h3>
        <h5>{t('Welcome_Product.tab_title')}</h5>
    <ul>
        <li>{t('Welcome_Product.list.1')}</li>
        <li>{t('Welcome_Product.list.2')}</li>
        <li>{t('Welcome_Product.list.3')}</li>
        <li>{t('Welcome_Product.list.4')}</li>
        </ul>
        <h4>{t('Welcome_Product.title2')}</h4>
        <p>{t('Welcome_Product.text')}</p>
        <BaseButton light href={lang === "FR" ? "https://pro.hellobank.be/fr/public/compte-professionnel" : "https://pro.hellobank.be/nl/public/zakelijke-rekening" } darkBlue> <IoMdOpen /> <span>{t('Welcome_Product.link')}</span>  </BaseButton>

        <h5>{t('Welcome_Product.tab_title2')}</h5>
        <p>{t('Welcome_Product.text2')}</p>


        <BaseButton light href={lang === "FR" ? "https://www.hellobank.be/docs/default-source/products/h10003/fr-a.pdf" : "https://www.hellobank.be/docs/default-source/products/h10003/nl-a.pdf" } darkBlue> <VscFilePdf /> <span>{t('Welcome_Product.documents.1')}</span>  </BaseButton>
        <BaseButton light href={lang === "FR" ? "https://pro.hellobank.be/media/document/docserver/H10203F.pdf" : "https://pro.hellobank.be/media/document/docserver/H10203N.pdf " } darkBlue> <VscFilePdf /> <span>{t('Welcome_Product.documents.2')}</span>  </BaseButton>
        <BaseButton light href={lang === "FR" ? "https://www.hellobank.be/docs/default-source/products/h10004/fr-a.pdf?sfvrsn=5f6bbaa3_102" : "https://www.hellobank.be/docs/default-source/products/h10004/nl-a.pdf?sfvrsn=5f6bbaa3_102" } darkBlue> <VscFilePdf /> <span>{t('Welcome_Product.documents.3')} </span></BaseButton>
        <BaseButton light href={lang === "FR" ? "https://pro.hellobank.be/media/document/docserver/H10204F.pdf " : "https://pro.hellobank.be/media/document/docserver/H10204N.pdf  " } darkBlue> <VscFilePdf /><span>{t('Welcome_Product.documents.4')}</span>  </BaseButton>
        <BaseButton light href={lang === "FR" ? "https://www.hellobank.be/docs/default-source/products/h10050/fr-a.pdf" : "https://www.hellobank.be/docs/default-source/products/h10050/nl-a.pdf" } darkBlue> <VscFilePdf /> <span>{t('Welcome_Product.documents.5')}</span> </BaseButton>
        <BaseButton light href={lang === "FR" ? "https://pro.hellobank.be/media/document/mention-legale.pdf" : "https://pro.hellobank.be/media/document/wettelijke-vermelding.pdf" } darkBlue> <VscFilePdf /> <span>{t('Welcome_Product.documents.6')}</span> </BaseButton>

    </>
)


const ProductPage = () => {
    const history = useHistory();
    const lang = localStorage.getItem('language')
    const { state, dispatch } = React.useContext(AppDataContext)
    const urlParams = new URLSearchParams(window.location.search);

    const base_URL = `${BASE_URL}/onboarding-entrepreneur-front/v1/step`
    const fetch_url = base_URL
    const fetchOption = {
        credentials: "include",
        mode: "cors",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',            
        }
    }


    const tagManagment = () => {
        // if (urlParams.has("SOURCETAG") || urlParams.has("sourcetag")) {
            fetch(fetch_url, {
                ...fetchOption,
                method: 'POST',
                body: JSON.stringify(
                [{
                    "fieldId": "source_tag",
                    "fieldValue": urlParams.get("SOURCETAG") || urlParams.get("sourcetag") || "NULL"
                    }]
                )
            }).then(res => {
                history.push(`/${lang.toLowerCase()}/welcome`)
            })
        // } else {
        //     history.push(`/${lang.toLowerCase()}/welcome`)
        // }
    };

    const action = () => {
        tagManagment()
    }


    React.useEffect(() => {
        if (localStorage.getItem('dataSent')) localStorage.removeItem('dataSent')
    
        if (PageBus) {
        PageBus.publish("analyticsServices",{
        pageID: "onboarding",
        stepSeq: "0",
        stepName: "welcome:product",
        flowType: "sales",
        flowName: "onboarding",
        productName: "onboarding",
        trackMethod: "flow"});
        }
    }, [])

    return (
            // <StepsWrapper stepGroupTitle={t('general.open_pro_account')} title={t('general.open_pro_account')}>
            <StepsWrapper stepGroupTitle={t('general.open_pro_account')} >
                <StepsLoader>
                <BaseParagraph someProperty={"Title"} >
                    <TextBody lang={ lang}/>
                    </BaseParagraph>
                    <div className={"footer-action"} style={{bottom: state.footer_height}}>
                        <BaseButton caption={t('Welcome_Product.cta')} action={action} link={`${lang.toLowerCase()}/welcome`} />
                    </div>
                </StepsLoader>
            </StepsWrapper>
    )
}

ProductPage.propTypes = {
    name: PropTypes.string
}

ProductPage.defaultProps = {
    name: "Step01"
}


export default ProductPage